import { render, staticRenderFns } from "./LabelPopover.vue?vue&type=template&id=a210e088&scoped=true&"
import script from "./LabelPopover.vue?vue&type=script&lang=js&"
export * from "./LabelPopover.vue?vue&type=script&lang=js&"
import style0 from "./LabelPopover.vue?vue&type=style&index=0&id=a210e088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a210e088",
  null
  
)

export default component.exports